import React, { useState, useEffect } from 'react';
import './GroupParam.css';
import './Lider.css';
import Man3 from '../media/imagen/3man.svg';

const Lider = ({ testID }) => {
    const [statusData, setStatusData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchStatusData = async () => {
            try {
                const token = localStorage.getItem('authToken');
                if (!token) throw new Error('Токен авторизации не найден');

                const response = await fetch(
                    `http://185.250.149.189:8000/api/v1/Results/Sociometric/Leaders?test_id=${testID}`,
                    {
                        method: 'GET',
                        headers: {
                            'Authorization': `Token ${token}`,
                            'Content-Type': 'application/json'
                        }
                    }
                );

                if (!response.ok) throw new Error(`Ошибка HTTP: ${response.status}`);
                const result = await response.json();
                setStatusData(result);
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchStatusData();
    }, [testID]);

    if (loading) return <div className="loading">Загрузка данных...</div>;
    if (error) return <div className="error">Ошибка: {error}</div>;
    if (!statusData) return <div className="no-data">Нет данных для отображения</div>;

    // Извлекаем первых кандидатов из каждого раздела
    const leaderName = statusData.results["Лидер"]?.[0] || "Не определено";
    const informalLeaderName = statusData.results["Неформальный лидер"]?.[0] || "Не определено";
    const conflictName = statusData.results["Конфликтный"]?.[0] || "Не определено";

    return (
        <div className='Lider'>
            <div className='Lider-container'>
                <div className='LiderBlock'>
                    <h2>Лидер</h2>
                    <span className='BigName'>{leaderName}</span>
                    <br />
                    <span className='Lider-des'>Лидер — это тот, у кого больше всего выборов по критерию «Лидерство».</span>
                    <div>
                        __________
                        <br /><br />
                        <span className='Lider-help'>Становясь лидером, человек часто утрачивает симпатии окружающих, потому что лидерство связано вмешательством в действие и его социальная роль связана с функцией управления. Изредко самый популярный и эмоционально комфортный человек (имеющий высокий положительный социометрический статус) является лидером. С другой стороны, лидер вызывает в других членах коллектива чувство надежности, даже безопасности, люди готовы доверять ему, делегировать принятие решений и ответственность, они выбирают за ним идти, что ставит его высоко в иерархии взаимодействий в коллективе.</span>
                    </div>
                </div>
                <div className='OtherLiderBlock'>
                    <div className='NeforLiderBlock'>
                        <h2>Неформальный лидер</h2>
                        <span className='BigName'>{informalLeaderName}</span>
                        <br />
                        <span className='Lider-des'>Неформальный лидер — тот, у кого больше всего выборов по критерию «Неформальный лидер»</span>
                    </div>
                    <div className='KonflicktLiderBlock'> 
                        <h2>Конфликтность</h2>
                        <span className='BigName'>{conflictName}</span>
                        <br />
                        <span className='Lider-des'>Конфликтный — тот, у кого больше всего отрицательных выборов по критерию «Конфликтность»</span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Lider;